import ServiceCategoryPage from "../components/ServiceCategoryPage";
import microwaveRepairService from "../data/services/microwaveRepairService";

function MicrowaveRepair() {
  return <ServiceCategoryPage service={microwaveRepairService} />;
}

export default MicrowaveRepair;